export default __webpack_public_path__ + "static/media/Q3_2.4af74ba8.jpg";